export const styles = (theme) => ({
  nodeInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'absolute',
    top: '74px',
  },
  settings: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    backgroundColor: 'rgba(64, 64, 64, 1)',
    borderRadius: '8px',
    height: '40px',
  },
  nodeWrapper: {
    width: '250px !important',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  node: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  nodeView: {
    display: 'flex',
    flexDirection: 'row',
  },
  rmvMargin: {
    margin: '0px!important',
    fontSize: '12px',
  },
  port: {
    position: 'relative !important',
    transform: 'unset !important',
    right: 'unset',
    top: '16px !important',
    height: '12px',
    width: '12px',
    backgroundColor: '#808080',
    borderRadius: '50%',
    border: '2px solid #fff',
    cursor: 'crosshair',
    // Invisible hit area for easier grabbing
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '-14px',
      left: '-14px',
      right: '-14px',
      bottom: '-14px',
      borderRadius: '50%',
    },
    '&:hover': {
      backgroundColor: '#2196f3',
      width: '18px',
      height: '18px',
      transition: 'all 0.1s',
    },
    '&:active': {
      backgroundColor: '#1976d2',
    },
  },
  filler: {
    width: '15px',
  },
  title: {
    fontSize: '8px',
  },
  nodeInfoBackground: {
    borderRadius: '8px',
    marginTop: '8px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  downsize: {
    height: '16px',
  },
  selectedText: {
    color: '#2196F3',
  },
  selectedIcon: {
    filter: 'drop-shadow(6px 6px 0px rgba(0, 0, 0, 0.25))',
  },
  centerGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  labelText: {
    maxWidth: '250px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  svg: {
    zIndex: 3,
  },
  addPathButton: {
    position: 'absolute',
    zIndex: '9999',
    left: '280px',
    top: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.palette.text.primary}`,
    background: theme.palette.background.paper,
    borderRadius: '4px',
    color: theme.palette.text.primary,
    padding: '8px',
    minWidth: '8px',
    '&:hover': {
      color: theme.palette.info.main,
      borderColor: theme.palette.info.main,
      cursor: 'pointer',
    },
  },
  addPathIcon: {
    height: '14px',
    width: 'auto',
  },
  addPathTooltipTitle: {
    fontSize: '12px',
  },

  actionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: '2px 4px',
    color: '#fff',
    '&:hover': {
      color: '#2196F3',
    },
  },
  actionText: {
    fontSize: '12px',
    marginLeft: '2px',
    userSelect: 'none',
  },
});
